<template>
  <div class="contact-form px-l mt-s" :class="[formSent ? 'thanku' : '']">
    <i v-if="formSent" class="thanku-icon fal" :class="['fa-paper-plane']"></i>
    <h3 class="pb-2xl font-rg" v-html="title"></h3>
    <div v-if="!formSent" class="contact-form--fields">
      <div class="contact-form--field">
        <input
          id="firstName"
          type="text"
          v-model="firstName"
          @focus="validations.firstName.valid = true"
          :class="{ filled: firstName, invalid: !validations.firstName.valid }"
          required
        />
        <label for="firstName">First Name *</label>
        <span
          v-if="!validations.firstName.valid"
          class="err"
          v-text="validations.firstName.msg"
        ></span>
      </div>
      <div class="contact-form--field">
        <input
          id="lastName"
          type="text"
          v-model="lastName"
          :class="{ filled: lastName }"
        />
        <label for="lastName">Last Name</label>
      </div>
      <div class="contact-form--field">
        <input
          id="email"
          type="email"
          v-model="email"
          @focus="validations.email.valid = true"
          :class="{ filled: email, invalid: !validations.email.valid }"
          required
        />
        <label for="email">Email *</label>
        <span
          v-if="!validations.email.valid"
          class="err"
          v-text="validations.email.msg"
        ></span>
      </div>
      <div class="contact-form--field">
        <input
          id="phone"
          type="phone"
          v-model="phone"
          :class="{ filled: phone }"
          required
        />
        <label for="phone">Phone Number</label>
      </div>
      <!-- <div class="contact-form--field">
        <input
          id="country"
          type="text"
          v-model="country"
          :class="{ filled: country }"
        />
        <label for="country">Country</label>
      </div> -->
      <div class="contact-form--field contact-form--field__radio">
        <label class="static" for="message">Are you a dentist?</label>
        <div class="radio-group">
          <label class="static" for="dentistYes">
            <input
              id="dentistYes"
              type="radio"
              name="dentist"
              v-model="field_of_activity"
              value="I am a dentist"
            />
            <span>Yes</span>
          </label>
          <label class="static" for="dentistNo">
            <input
              id="dentistNo"
              type="radio"
              name="dentist"
              v-model="field_of_activity"
              value="I am not a dentist"
            />
            <span>No</span>
          </label>
        </div>
      </div>
      <div :class="['contact-form--field', 'checkbox']">
        <input
          ref="solicitCheck"
          id="solicit"
          v-model="solicit"
          type="checkbox"
        />
        <!-- <label for="solicit" v-text="isMobile ? 'MIS\'ten güncellemeler almak istiyorum' : 'Ürünler ve hizmetler, özel teklifler, haberler ve etkinlikler hakkında güncellemeler almak istiyorum.'"></label> -->
        <label
          class="static"
          for="solicit"
          v-text="
            'I would like to receive updates about products and services, special offers, news and events.'
          "
        ></label>
      </div>
    </div>
    <abtn
      v-if="!formSent"
      @click.native.prevent="submit"
      color="blue"
      :class="['self-end mt-xl']"
      :loading="sending"
      mini
    >
      <span v-text="localize('submit')"></span>
    </abtn>

    <ul v-if="submitErrors.length" class="err-log p-xl my-xl">
      <li v-for="err in submitErrors" :key="err.errorType">
        <i class="fal fa-exclamation-circle mr-xs"></i>
        <span v-text="err.message"></span>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
export default {
  data() {
    return {
      formSent: false,
      // title: "For more information please send us a message:",
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      field_of_activity: null,
      country: "",
      message: "",
      solicit: false,
      // eslint-disable-next-line
      email_rx: /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      validations: {
        firstName: {
          valid: true,
          msg: "* Field is required"
        },
        lastName: {
          valid: true,
          msg: "* Field is required"
        },
        email: {
          valid: true,
          msg: "* Field is required"
        }
      },
      submitErrors: [],
      sending: false,
      formIds: {
        3418: "51b25325-c3ed-4161-bdc4-40504fe00c09"
      }
    };
  },
  methods: {
    submit() {
      this.sending = true;
      if (this.formIsValid()) {
        console.log("FORM is valid");
        // SUBMIT TO HUBSPOT
        this.submitFormToHubspot();
      } else {
        console.log("FORM is NOT valid");
        this.sending = false;
      }
    },
    formIsValid() {
      let v = this.validations;
      v.firstName.valid = true;
      // v.lastName.valid = true;
      v.email.valid = true;
      if (!this.firstName) {
        this.$set(v.firstName, "valid", false);
      }
      // if (!this.lastName) {
      //   this.$set(v.lastName, "valid", false);
      // }
      if (!this.email) {
        this.$set(v.email, "valid", false);
        // this.$set(v.email, 'msg', '* Bereich ist obligatorisch');
      } else if (!this.email_rx.test(this.email)) {
        console.log("EMAIL not valid > ", v.email);
        this.$set(v.email, "valid", false);
        this.$set(v.email, "msg", "Please enter valid email");
      }
      return !_.reject(v, "valid").length;
    },
    getCookie(cname) {
      var name = cname + "=";
      var ca = document.cookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },
    async submitFormToHubspot() {
      this.sending = true;
      let hutk = this.getCookie("hubspotutk");
      let vm = this,
        formId = this.formIds[this.pageCid],
        pageName = this.pageName,
        pageUri = this.pageUri;

      if (formId) {
        let _HUBSPOTURL = `https://api.hsforms.com/submissions/v3/integration/submit/3835094/${formId}`;
        let data = {
          submittedAt: new Date().getTime(),
          fields: [
            {
              name: "firstname",
              value: this.firstName
            },
            {
              name: "lastname",
              value: this.lastName
            },
            {
              name: "email",
              value: this.email
            },
            {
              name: "phone",
              value: this.phone
            },
            // {
            //   name: "country",
            //   value: this.country
            // },
            {
              name: "field_of_activity",
              value: this.field_of_activity
            },
            {
              name: "LEGAL_CONSENT.subscription_type_4847424",
              value: this.solicit
            }
          ],
          context: {
            pageUri,
            pageName
          },
          skipValidation: false
        };
        if (hutk) {
          data.context["hutk"] = hutk;
        }
        vm.$set(vm, "submitErrors", []);
        fetch(_HUBSPOTURL, {
          method: "POST",
          mode: "cors", // no-cors, *cors, same-origin
          cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
          credentials: "same-origin", // include, *same-origin, omit
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
            // 				'Access-Control-Allow-Origin': '*'
          },
          // redirect: "follow", // manual, *follow, error
          referrerPolicy: "no-referrer", // no-referrer, *client
          body: JSON.stringify(data) // body data type must match "Content-Type" header
        })
          .then(function(response) {
            console.log("FIRST THEN RESPONSE  < ", response);
            return response.json();
          })
          .then(
            async function(json) {
              console.log("response from hubspot submit >> ", json);
              vm.sending = false;

              if (json.status && json.status && json.status === "error") {
                console.log("[fetch|error] register user >> ", json);
                vm.$set(vm, "submitErrors", json.errors);
                throw new Error(json.message);
              } else {
                vm.formSent = true;
                // vm.title =
                //   "Thank you for contacting us. We will get back to you shortly.";
              }
            },
            error => {
              vm.sending = false;
              console.log("[fetch|error] register user >> ", error);
              throw new Error(error);
            }
          );
      }
    }
  },
  computed: {
    ...mapGetters(["localeString"]),
    ...mapState(["pageCid", "pageLayoutData"]),
    title() {
      return !this.formSent
        ? this.localize("send_us_msg")
        : this.localize("contact_thanks");
    },
    pageName() {
      if (this.pageLayoutData && this.pageLayoutData.title) {
        return this.pageLayoutData.title;
      }
      return "MIS Global";
    },
    pageUri() {
      return window.location.href || "https://www.mis-implants.com";
    }
  }
};
</script>
<style lang="stylus" scoped>
.err-log
  background rgba(red_3, 0.3)
  li:not(:last-child)
    marg('s', bottom)
  i
  span
    color red_6

.radio-group
  margin-top 10px
  label
    _flex(row, wrap, center, flex-start, inline)
    margin-right 10px

    span
      font-size 16px
.thanku-icon
  font-size responsive 30px 50px
  display block
  margin 20px auto 40px
.contact-form
    background gray_1
    padding-top 5vh
    padding-bottom 5vh
    min-width 200px
    +below(600px) //dubi
      padding-left 8.5vw
      padding-right 8.5vw
    _flex(column, wrap, stretch, center)
    &--field
        position relative
        height 40px
        marg('xl',bottom)
        clear: fix;
        +below(415px)
          height 30px
        &__textarea
          padding-top 20px
          height 120px
          +below(415px)
            height 80px
        .err
          color red_4
          float right
        label:not(.static)
            position absolute
            left 0
            top 0
            transform translateY(10px)
            font-size responsive 16px 20px
            transition transform 0.3s ease-out-cubic, font-size 0.3s ease-out-cubic
        input:not([type='checkbox']):not([type='radio'])
        textarea
            border none
            background none
            height 100%
            width 100%
            border-bottom 1px solid gray_3
            transition border 0.3s ease-out-cubic
            appearance none
            border-radius none
            &:focus
            &.filled
                border-bottom 1px solid blue_3
                outline 0
                & + label
                    transform translateY(-15px)
                    font-size 86%
            &.invalid
                border-bottom 1px solid red_3
        input[type='checkbox']
          float left
          & + label
            overflow hidden
            display block
</style>
